import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    size: 257,
    bgColor: '#fff',
    fgColor: '#000',
    value: 'https://github.com/l-ll/qrcode-vue',
    offers: [],
    platformId: null,
  },
  getters: {
    getListOfBestOffers(state) {
      const listOfBestOffers = state.offers.slice(0, 4);
      return listOfBestOffers;
    },
    getListOfEmbeddedOffers(state) {
      if (state.offers.length < 7) {
        return []
      }

      const filteredEmbedded = state.offers.slice(0, 7);
      const mapPositions = [
        1, 2, 3, 4,
        5, 6, 1, 7,
        2, 3, 6, 5,
        3, 1, 4, 2
      ];

      let res = [];

      mapPositions.forEach ((position) => {
        res.push(filteredEmbedded[position - 1]);
      })

      return res;

    },
    offers: (state => state.offers),
    partnersOffers: (state => state.offers.filter(item => item.is_pwa === false)),
    popupOffers: (state => state.offers.filter(item => item.is_pwa === false).slice(-3)),
    tizers: (state => state.offers.filter(item => item.is_pwa === false).slice(0, 1)),
    pwa:( state => state.offers.find(item => item.is_pwa === true))
  },
  mutations: {
    SET_Offers (state, items) {
      state.offers = items
    },
    setPlatformId (state, platformId) {
      state.platformId = platformId;
    },
  },
  actions: {
    initLoadOffers({ commit, dispatch }, options) {
      const platformId = options?.platform_id ?? process.env.VUE_APP_DEFAULT_PLATFORM;
      const categories = options?.category ?? [14];

      commit('setPlatformId', platformId);

      const key = `_offers_${platformId}_${categories.join('.')}`;
      let data = localStorage.getItem(key);
      if (data) {
        data = JSON.parse(data);
        const ttlDate = new Date(data.ttl);
        if (data && ttlDate > (new Date())) {
          commit('SET_Offers', data.items);
          return;
        }
      }

      return dispatch('loadOffers', {
        categoryIds: categories,
        platformId: platformId
      });
    },
    loadOffers ({ commit }, { categoryIds, platformId }) {
      
      return axios
          .get(`${process.env.VUE_APP_API_URL}?platformId=${platformId}&categoryIds[]=${categoryIds[0]}`, {
          })
          .then(response => response.data.data)
          .then(items => {
            commit('SET_Offers', items);

            const key = `_offers_${platformId}_${categoryIds.join('.')}`;
            const ttlDate = new Date();
            ttlDate.setSeconds(ttlDate.getSeconds() + 10 * 60);
            localStorage.setItem(key, JSON.stringify({
              ttl: ttlDate,
              items: items
            }));
          })
          .catch (e => console.log(e))
    },
  },
  modules: {
  }
})
